import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RestAPI } from "@aws-amplify/api-rest";
import LoadingDialog from "../Utils/LoadingDialog";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "../Form/FormStyles.css";
import dayjs from "dayjs";
import { dateFormat } from "../../utils/date";

import withName from "../../hoc/withName";
import Charts from "./Charts";
import GraficadorRow from "./GraficadorRow";

import SelfHelp from "../Utils/SelfHelp";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import { Column } from "primereact/column";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";
import { Button } from "primereact/button";

const Graficador = ({ dataFarm, nodes, menuIsOpen }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [columnDict, setColumnDict] = useState(null);
    const [showValidation, setShowValidation] = useState(false);
    const [showValidation90Days, setShowValidation90Days] = useState(false);
    const [showValidation6M, setShowValidation6M] = useState(false);
    const [showValidationGraficador, setShowValidationGraficador] = useState(false);
    const [showValidationGraficadorUnique, setShowValidationGraficadorUnique] = useState(false);
    const [firstExec, setFirstExec] = useState(true);
    const [dropdownData, setDropdownData] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const [nodesInfo, setNodesInfo] = useState(null);
    const [dataChart, setDataChart] = useState(null);
    const [fechasChart, setFechasChart] = useState(null);
    const [sensoresChart, setSensoresChart] = useState(null);
    const today = new Date();
    const sixMonths = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 179);
    const colors = ["#1f34d1", "#f05656", "#15d522", "#ff9500", "#c800ff", "#00ffd5"];
    const [rows, setRows] = useState([{ key: 0, nodo: null, sensor: null, color: colors[0] }]);
    const [tableData, setTableData] = useState(null);
    const [tableRows, setTableRows] = useState([]);
    const [loadUrl, setLoadUrl] = useState(false);
    const [limitSensor, setLimitSensor] = useState(false);
    const [rangeDates, setRangeDates] = useState(null);

    const [options, setOptions] = useState({
        chart: {
            zoomType: "x",
            hideNoData: true,
            showNoData: t("forms.graphNoData")
        },
        title: {
            text: null
        },
        subtitle: {
            text: null,
            align: "left"
        },
        lang: {
            noData: t("forms.graphNoData")
        },
        time: {
            //timezone: dataFarm.huso_horario,
            useUTC: true
        },
        rangeSelector: {
            enabled: true,
            verticalAlign: "top",
            x: 0,
            y: 0,
            buttons: [
                {
                    type: "day",
                    count: 7,
                    text: t("graficador.7d"),

                }, {
                    type: "day",
                    count: 30,
                    text: t("graficador.30d")
                }, {
                    type: "day",
                    count: 60,
                    text: t("graficador.60d")
                },
                {
                    type: "all",
                    text: t("graficador.todo")
                }
            ]
        },
        series: [],
        credits:
        {
            enabled: false
        },
        tooltip: {
            shared: true
        },
        legend: {
            enabled: true
        }
    });

    const selfHelpImg1 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-11.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-11.png`];
    const selfHelpImg2 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-12.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-12.png`];
    const selfHelpImg3 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-13.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-13.png`];
    const selfHelpImg4 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-14.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-14.png`];
    const selfHelpImg5 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-15.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-15.png`];
    const selfHelpImg6 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-16.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-16.png`];
    const selfHelpImg7 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-17.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-17.png`];
    const selfHelpImg8 = import.meta.glob("../../img/autoayuda/*/autoayuda-graficador-18.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-graficador-18.png`];

    const selfHelpGraficador = [
        {
            tab: 1, header: { text: t("selfHelp.instructions") }, params:
                [
                    { id: 1, text: t("selfHelp.graficador.msgIntro"), image: [] },
                    { id: 2, text: t("selfHelp.graficador.msgSensores1"), image: selfHelpImg1 },
                    { id: 3, text: t("selfHelp.graficador.msgSensores2"), image: selfHelpImg2 },
                    { id: 4, text: t("selfHelp.graficador.msgSensores3"), image: selfHelpImg3 },
                    { id: 5, text: t("selfHelp.graficador.msgSensores4"), image: selfHelpImg4 },
                    { id: 6, text: t("selfHelp.graficador.msgFecha1"), image: [] },
                    { id: 7, text: t("selfHelp.graficador.msgFecha2"), image: selfHelpImg5 },
                    { id: 8, text: t("selfHelp.graficador.msgFecha3"), image: selfHelpImg6 },
                    { id: 9, text: t("selfHelp.graficador.msgGraficador1"), image: selfHelpImg7 },
                    { id: 10, text: t("selfHelp.graficador.msgGraficador2"), image: selfHelpImg8 }
                ]
        }
    ];
    useEffect(() => {
        async function getDatos() {
            const data = await RestAPI.get("apiAdminDropControl", `/farms/${dataFarm.campo_id}/nodes`).catch(e => { console.log(e); return []; });
            const params = new URLSearchParams(location && location.search);
            const sensorsIds = JSON.parse(params.get("sensors"));
            let fromUrl = false;
            if (sensorsIds && sensorsIds.length > 0) {
                fromUrl = true;
            }
            const urlRows = [];
            let i = 1;
            data.forEach(n => {
                n.nombre = n.nombre.split("[")[0];
            });
            const arr = [];
            for (const nodo of data) {
                const obj = {
                    nodo_id: nodo.nodo_id,
                    nombre: nodo.nombre,
                    sensores: []
                };
                if (nodo.sist_sensores) {
                    for (const sensor of nodo.sist_sensores) {
                        let groupIndex =obj?.sensores?.findIndex(item => item?.label===t("graficador.sensor_sistema"));
                        if(groupIndex===-1){
                            obj.sensores.push( {label: t("graficador.sensor_sistema"), items: []});
                            groupIndex = (obj?.sensores?.length) -1;
                        }
                        const groupObj = {
                            tipo: t("graficador.sensor_sistema"),
                            nodo_id: sensor.nodo_id,
                            sensor_id: parseInt("1" + sensor.sist_sensor_id, 10),
                            original_id:sensor.sist_sensor_id,
                            nombre: sensor.tipo[i18n.language] ?? sensor.tipo["en"],
                            sist_tipo_sensor_id: sensor.sist_tipo_sensor_id,
                            simbolo: sensor.simbolo,
                            data_operation: sensor.data_operation,
                            traduccion: sensor.tipo
                        };
                        obj.sensores[groupIndex].items.push({...groupObj});

                        if (fromUrl) {
                            if (sensorsIds.includes(groupObj.sensor_id)) {
                                urlRows.push({
                                    key: i,
                                    nodo: {
                                        id: nodo.nodo_id,
                                        nombre: nodo.nombre
                                    },
                                    sensor: {...groupObj, ddData:{...groupObj}},
                                    color: colors[i - 1]
                                });
                                i += 1;
                            }
                        }
                    }
                }
                if (nodo.sensores) {
                    for (const sensor of nodo.sensores) {
                        let groupIndex =obj?.sensores?.findIndex(item => item?.label===t("graficador.sensor_real"));
                        if(groupIndex===-1){
                            obj.sensores.push( {label: t("graficador.sensor_real"), items: []});
                            groupIndex = (obj?.sensores?.length) -1;
                        }
                        const groupObj = {
                            tipo: t("graficador.sensor_real"),
                            nodo_id: sensor.nodo_id,
                            sensor_id: parseInt("2" + sensor.sensor_id, 10),
                            original_id:sensor.sensor_id,
                            nombre: sensor.nombre,
                            sist_tipo_sensor_id: sensor.sist_tipo_sensor_id,
                            simbolo: sensor.simbolo,
                            data_operation: sensor.data_operation
                        };
                        obj.sensores[groupIndex].items.push({...groupObj});
                        if (fromUrl) {
                            if (sensorsIds.includes(groupObj.sensor_id)) {
                                urlRows.push({
                                    key: i,
                                    nodo: {
                                        id: nodo.nodo_id,
                                        nombre: nodo.nombre
                                    },
                                    sensor: {...groupObj, ddData:{...groupObj}},
                                    color: colors[i - 1]
                                });
                                i += 1;
                            }
                        }
                    }
                }
                if (nodo.derivados) {
                    for (const sensor of nodo.derivados) {
                        let groupIndex =obj?.sensores?.findIndex(item => item?.label===t("graficador.sensor_virtual"));
                        if(groupIndex===-1){
                            obj.sensores.push( {label: t("graficador.sensor_virtual"), items: []});
                            groupIndex = (obj?.sensores?.length) -1;
                        }
                        const groupObj = {
                            tipo: t("graficador.sensor_virtual"),
                            nodo_id: sensor.nodo_id,
                            sensor_id: parseInt("3" + sensor.sensor_virtual_derivado_id, 10),
                            nombre: sensor.nombre,
                            sist_tipo_sensor_id: sensor.sist_tipo_sensor_id,
                            simbolo: sensor.simbolo,
                            data_operation: sensor.data_operation,
                            original_id:sensor.sensor_virtual_derivado_id,
                        };
                        obj.sensores[groupIndex].items.push({...groupObj});

                        if (fromUrl) {
                            if (sensorsIds.includes(groupObj.sensor_id)) {
                                urlRows.push({
                                    key: i,
                                    nodo: {
                                        id: nodo.nodo_id,
                                        nombre: nodo.nombre
                                    },
                                    sensor: {...groupObj, ddData:{...groupObj}},
                                    color: colors[i - 1]
                                });
                                i += 1;
                            }
                        }
                    }
                }
                obj.sensores.forEach(o => {
                    if(o?.items?.length >0){
                        o.items[o.items.length-1].lastSensor = true;
                    }

                });
                arr.push(obj);
            }
            if(arr.length >0){
                arr[arr.length-1].lastNode = true;
            }
            setNodesInfo(data);
            setDropdownData(arr);
            if (urlRows.length > 0) {
                setLoadUrl(true);
                setRows(urlRows);
            }

            //setRows([<GraficadorRow nodesInfo={arr} t={t} obj={{ nodo: null, sensor: null, color: '#1f34d1' }} />])
        }
        if (firstExec) {
            setDataLoading(true);
            getDatos();
            setFirstExec(false);
            setTimeout(() => { setDataLoading(false); }, 1000);
        }
    }, [firstExec]);

    const addRow = () => {
        if (rows.length < 6) {
            const colorsUsed = [];
            for (const row of rows) {
                colorsUsed.push(row.color);
            }
            const colorsNotUsed = colors.filter(value => !colorsUsed.includes(value));
            let lastKey = -1;
            for (const row of rows) {
                if (row.key > lastKey) {
                    lastKey = row.key;
                }
            }
            setRows(rows.concat({ key: lastKey + 1, nodo: null, sensor: null, color: colorsNotUsed[0] }));
        }
    };

    const addRowNextNodo = (index) => {
        if (rows[index].nodo !== null && rows.length < 6) {
            const current = rows[index];
            let lastKey = -1;
            for (const row of rows) {
                if (row.key > lastKey) {
                    lastKey = row.key;
                }
            }

            const colorsUsed = [];
            for (const row of rows) {
                colorsUsed.push(row.color);
            }
            const colorsNotUsed = colors.filter(value => !colorsUsed.includes(value));

            const nextNodo = { key: lastKey + 1, nodo: null, sensor: null, color: colorsNotUsed[0] };
            for (let i = 0; i < dropdownData.length; i++) {
                if (dropdownData[i].nodo_id === rows[index].nodo.id) {
                    if (dropdownData[i + 1]) {
                        nextNodo.nodo = {};
                        nextNodo.nodo.id = dropdownData[i + 1].nodo_id;
                        nextNodo.nodo.nombre = dropdownData[i + 1].nombre;
                        if (current.sensor) {
                            for (const sensor of dropdownData[i + 1].sensores) {
                                if (current.sensor.sist_tipo_sensor_id === sensor.sist_tipo_sensor_id) {
                                    nextNodo.sensor = sensor;
                                    break;
                                }
                            }
                        }
                        setRows(rows.slice(0, index + 1).concat([nextNodo].concat(rows.slice(index + 1, rows.length))));
                        break;
                    }
                }
            }

        }
    };

    const addRowNextSensor = (index, type) => {
        let _sensorList = "sensores";
        let _sensorId = "sensor_id";
        if(t("graficador.sensor_virtual")===type){
            _sensorList = "derivados";
            _sensorId = "sensor_virtual_derivado_id";
        }
        else if(t("graficador.sensor_sistema")===type){
            _sensorList = "sist_sensores";
            _sensorId = "sist_sensor_id";
        }
        if (rows[index].sensor !== null && rows.length < 6) {
            let lastKey = -1;
            for (const row of rows) {
                if (row.key > lastKey) {
                    lastKey = row.key;
                }
            }

            const colorsUsed = [];
            for (const row of rows) {
                colorsUsed.push(row.color);
            }
            const colorsNotUsed = colors.filter(value => !colorsUsed.includes(value));

            const nextSensor = { key: lastKey + 1, nodo: rows[index].nodo, sensor: null, color: colorsNotUsed[0] };
            for (let i = 0; i < nodesInfo.length; i++) {
                if (nodesInfo[i].nodo_id === rows[index].nodo.id) {
                    for (let j = 0; j < nodesInfo[i][_sensorList].length; j++) {
                        if (nodesInfo[i][_sensorList][j][_sensorId] === rows[index].sensor?.ddData?.original_id || nodesInfo[i][_sensorList][j][_sensorId] === rows[index].sensor?.ddData?.sensor_id) {
                            if (nodesInfo[i][_sensorList][j + 1]) {
                                nextSensor.sensor = {...nodesInfo[i][_sensorList][j + 1]};
                                const typeIndex = dropdownData[i].sensores.find((e) => e.label===rows[index].sensor.ddData.tipo);
                                const newSensorGrouped = typeIndex.items.find((i) => i.original_id === nextSensor.sensor[_sensorId]);
                                nextSensor.sensor.ddData= newSensorGrouped;
                                nextSensor.sensor.original_id=newSensorGrouped.original_id;
                                nextSensor.sensor.sensor_id=newSensorGrouped.sensor_id;
                                setRows(rows.slice(0, index + 1).concat([nextSensor].concat(rows.slice(index + 1, rows.length))));
                            }
                            break;
                        }
                    }
                    break;
                }
            }
        }
    };

    const removeRow = (index) => {
        if (rows.length > 1) {
            setRows(rows.slice(0, index).concat(rows.slice(index + 1)));
        }
    };

    const updateRow = (index, updatedObj) => {
        setRows(rows.map((row, id) => {
            if (index === id) {
                return updatedObj;
            }
            return row;
        }));
    };

    useEffect(() => {
        if (loadUrl && !rangeDates) {
            const params = new URLSearchParams(location && location.search);
            const dates = JSON.parse(params.get("dates"));
            if (dates && dates.length === 2) {

                const preRangeDates = [new Date(dates[0].replace(/-/g, "/"))];
                if (new Date(dates[1]).toDateString() === today.toDateString()) {
                    preRangeDates.push(today);
                } else {
                    preRangeDates.push(new Date(dates[1].replace(/-/g, "/")));
                }
                setRangeDates(preRangeDates);
                obtenerDatos(preRangeDates);
            }
            setLoadUrl(false);
        }

        if (rows.length >= 6) {
            setLimitSensor(true);
        } else {
            setLimitSensor(false);
        }
    }, [rows, rangeDates]);

    const updateChart = (chartData, fecha) => {
        const basicOptions = {
            chart: {
                zoomType: "x",
                hideNoData: true,
                showNoData: t("forms.graphNoData")
            },
            title: {
                text: null
            },
            subtitle: {
                text: null,
                align: "left"
            },
            lang: {
                noData: t("forms.graphNoData")
            },
            time: {
                //timezone: dataFarm.huso_horario,
                useUTC: true
            },
            rangeSelector: {
                enabled: true,
                verticalAlign: "top",
                x: 0,
                y: 0,
                buttons: [
                    {
                        type: "day",
                        count: 7,
                        text: t("graficador.7d"),

                    }, {
                        type: "day",
                        count: 30,
                        text: t("graficador.30d")
                    }, {
                        type: "day",
                        count: 60,
                        text: t("graficador.60d")
                    },
                    {
                        type: "all",
                        text: t("graficador.todo")
                    }
                ]
            },
            xAxis: [{ // Bottom X axis
                type: "datetime",
                crosshair: true,
                tickLength: 0,
                min: dayjs.utc(fecha[0]).valueOf(),
                max: dayjs.utc(fecha[1] + " 23:59:59").valueOf(),
            }],
            yAxis: [],
            series: [],
            credits:
            {
                enabled: false
            },
            tooltip: {
                shared: true
            },
            legend: {
                enabled: true,
                labelFormatter: function () {
                    return "<b>" + this.name + "</b>";
                }
            },
            plotOptions: {
                line: {
                    dataGrouping: {
                        enabled: true
                    },
                    gapUnit: "value"
                }
            }
        };

        let currentYAxis = 0;
        const indexes = {};

        const sensorsWithNoData = [];
        for (const row of rows) {
            let found = false;
            for (const data of chartData) {
                if (data.length === 0) {
                    continue;
                }
                if (data[0].sensor_id === row.sensor.sensor_id) {
                    found = true;
                }
            }
            if (!found) {
                sensorsWithNoData.push(row.sensor.sensor_id);
            }
        }

        let opposite = false;
        for (const row of rows) {
            if (sensorsWithNoData.includes(row.sensor.sensor_id)) {
                continue;
            }
            const info = row;
            if (!Object.prototype.hasOwnProperty.call(indexes, info.sensor.simbolo)) {
                const yAxis = {
                    type: "treegrid",
                    opposite: opposite,
                    labels: {
                        style: {
                            fontWeight: "bold"
                        }
                    },
                    title: {
                        text: info.sensor.simbolo,
                        style: {
                            fontWeight: "bold"
                        }
                    }
                };

                const yAxisArr = basicOptions.yAxis;
                yAxisArr.push(yAxis);
                basicOptions.yAxis = yAxisArr;
                indexes[info.sensor.simbolo] = currentYAxis;
                currentYAxis += 1;
                opposite = !opposite;
            }
        }

        const operations = {
            MIN: function (data) {
                return Math.min(data);
            },
            MAX: function (data) {
                return Math.max(data);
            },
            SUM: function (data) {
                return data.reduce((a, b) => a + b, 0);
            }
        };

        for (const data of chartData) {
            const xData = [];
            let sensor_id = null;
            for (const sensorData of data) {
                if (sensor_id === null) {
                    sensor_id = sensorData.sensor_id;
                }
                xData.push([dayjs.utc(sensorData.fecha).valueOf(), sensorData.valor]);
            }

            if (sensor_id !== null) {
                let info = null;
                for (const row of rows) {
                    if (row.sensor.sensor_id === sensor_id) {
                        info = row;
                        break;
                    }
                }

                const serie = {
                    type: "line",
                    name: info.nodo.nombre + " - " + info.sensor.nombre,
                    color: info.color,
                    yAxis: indexes[info.sensor.simbolo],
                    data: xData,
                    tooltip: {
                        format: `<b> {series.name}</b>: <b>{point.y}</b> [<b>${info.sensor.simbolo}</b>]`
                    }
                };

                if (info.sensor.data_operation !== null && info.sensor.data_operation !== "AVG") {
                    serie.dataGrouping = {
                        approximation: operations[info.sensor.data_operation]
                    };
                }

                const seriesArr = basicOptions.series;


                seriesArr.push(serie);

                basicOptions.series = seriesArr;
            }

        }
        setOptions(basicOptions);
    };

    const updateTable = (data, sensoresArr) => {
        const convertedData = [];

        const template = (field, params) => {
            return dateFormat(params[field], null, i18n.language, null, false, true);
        };

        let lastKey = null;

        if (tableRows && tableRows.length > 0) {
            for (const tr of tableRows) {
                if (lastKey === null || lastKey < parseInt(tr.key)) lastKey = parseInt(tr.key);
            }
        }
        const r = [<Column key={lastKey === null ? 0 : lastKey + 1} sortable field="fecha" header={t("forms.fecha")} type="string" style={{textAlign:"Left"}} body={(e) => template("fecha", e)}
            headerClassName="dataTablePrimeHeader"
        />];
        //console.log("arr", sensoresArr);
        const preDictColumns = {};
        for (const sensor of sensoresArr) {
            let nodo;
            for (const info of nodesInfo) {
                if (info.nodo_id === sensor.nodo_id) {
                    nodo = info;
                    break;
                }
            }

            const header = nodo.nombre + " - " + (sensor.traduccion ? (sensor.traduccion[i18n.language] ?? sensor.traduccion["en"]) : sensor.nombre) + " [" + sensor.simbolo + "]";
            preDictColumns[sensor.sensor_id] = header;
            const template = (field, params) => {
                const number = params[field];
                return t("general.number", { value: number }) || "-";
            };
            r.push(
                <Column key={lastKey === null ? r.length : (lastKey + r.length + 1)} sortable
                    field={sensor.sensor_id.toString()} header={header} style={{textAlign:"Left"}} body={(e) => template(sensor.sensor_id.toString(), e)}
                    headerClassName="dataTablePrimeHeader"
                />);

        }
        setColumnDict(preDictColumns);
        setTableRows(r);
        for (const dt of data) {
            for (const d of dt) {
                const obj = {};
                obj.fecha = d.fecha;
                for (const sensor of sensoresArr) {
                    if (sensor.sensor_id === d.sensor_id) {
                        obj[sensor.sensor_id] = d.valor;
                    }
                }
                convertedData.push(obj);
            }
        }

        if (data.length > 1) {

            const reducedData = [];

            convertedData.forEach(function (obj) {
                if (!this[obj.fecha]) {
                    this[obj.fecha] = { fecha: dayjs.utc(obj.fecha) };
                    for (const sensor of sensoresArr) {
                        if (sensor.sensor_id in obj) {
                            this[obj.fecha][sensor.sensor_id] = obj[sensor.sensor_id];
                            reducedData.push(this[obj.fecha]);
                            return;
                        }
                    }
                }

                for (const sensor of sensoresArr) {
                    if (sensor.sensor_id in obj) {
                        this[obj.fecha][sensor.sensor_id] = obj[sensor.sensor_id];
                    }
                }

            }, Object.create(null));
            setTableData(reducedData);
        } else {
            setTableData(convertedData);
        }
    };

    const obtenerDatos = async (dates) => {
        setShowValidation(false);
        setShowValidation6M(false);
        setShowValidationGraficador(false);
        setShowValidationGraficadorUnique(false);
        setShowValidation90Days(false);
        !dataLoading && setDataLoading(true);
        if (!dates?.[0] || !dates?.[1]) {
            !showValidation && setShowValidation(true);
            setDataLoading(false);
            return;
        } else if (dates?.[0] < sixMonths) {
            !showValidation6M && setShowValidation6M(true);
            setDataLoading(false);
            return;
        } else if ((dates?.[0].getTime() - dates?.[0].getTime()) > (90 * 24 * 60 * 60 * 1000)) {
            !showValidation90Days && setShowValidation90Days(true);
            setDataLoading(false);
            return;
        } else if (dates?.[1] > today) {
            !showValidation && setShowValidation(true);
            setDataLoading(false);
            return;
        }

        const sensoresIds = [];
        const sensoresObj = [];
        for (const row of rows) {
            if (!row.nodo || !row.sensor) {
                !showValidationGraficador && setShowValidationGraficador(true);
                setDataLoading(false);
                return;
            }
            if (sensoresIds.includes(row.sensor.sensor_id)) {
                !showValidationGraficadorUnique && setShowValidationGraficadorUnique(true);
                setDataLoading(false);
                return;
            }
            sensoresObj.push(row.sensor);
            sensoresIds.push(row.sensor.sensor_id);
        }
        let fechas = [dates?.[0].toISOString(), dates?.[1].toISOString()];
        fechas = [fechas[0].split("T")[0].replace(/-/g, "/"), fechas[1].split("T")[0].replace(/-/g, "/")];

        const param = `/graficador/${dataFarm.campo_id}?sensores=${JSON.stringify(sensoresIds)}&fechas=${JSON.stringify(fechas)}`;

        const params = new URLSearchParams(location && location.search);
        const newParams = new URLSearchParams({ farm: params.get("farm"), sensors: sensoresIds.toString(), dates: fechas.toString() });
        navigate({ pathname: "/farms/customchart", search: `?farm=${dataFarm.campo_id}&sensors=${JSON.stringify(sensoresIds)}&dates=${JSON.stringify(fechas)}` });

        const data = await RestAPI.get("apiAdminDropControl", param).catch(e => { console.log(e); return []; });
        setDataChart(data);
        setFechasChart(fechas);
        setSensoresChart(sensoresObj);

        setDataLoading(false);

    };
    useEffect(() => {
        if (!firstExec && nodesInfo) {
            const arr = [];
            for (const nodo of nodesInfo) {
                const obj = {
                    nodo_id: nodo.nodo_id,
                    nombre: nodo.nombre,
                    sensores: []
                };
                if (nodo.sist_sensores) {
                    for (const sensor of nodo.sist_sensores) {
                        let groupIndex =obj?.sensores?.findIndex(item => item?.label===t("graficador.sensor_sistema"));
                        if(groupIndex===-1){
                            obj.sensores.push( {label: t("graficador.sensor_sistema"), items: []});
                            groupIndex = (obj?.sensores?.length) -1;
                        }
                        const groupObj = {
                            tipo: t("graficador.sensor_sistema"),
                            nodo_id: sensor.nodo_id,
                            sensor_id: parseInt("1" + sensor.sist_sensor_id, 10),
                            original_id:sensor.sist_sensor_id,
                            nombre: sensor.tipo[i18n.language] ?? sensor.tipo["en"],
                            sist_tipo_sensor_id: sensor.sist_tipo_sensor_id,
                            simbolo: sensor.simbolo,
                            data_operation: sensor.data_operation,
                            traduccion: sensor.tipo
                        };
                        obj.sensores[groupIndex].items.push(groupObj);
                    }
                }
                if (nodo.sensores) {
                    for (const sensor of nodo.sensores) {
                        let groupIndex =obj?.sensores?.findIndex(item => item?.label===t("graficador.sensor_real"));
                        if(groupIndex===-1){
                            obj.sensores.push( {label: t("graficador.sensor_real"), items: []});
                            groupIndex = (obj?.sensores?.length) -1;
                        }
                        const groupObj = {
                            tipo: t("graficador.sensor_real"),
                            nodo_id: sensor.nodo_id,
                            sensor_id: parseInt("2" + sensor.sensor_id, 10),
                            original_id:sensor.sensor_id,
                            nombre: sensor.nombre,
                            sist_tipo_sensor_id: sensor.sist_tipo_sensor_id,
                            simbolo: sensor.simbolo,
                            data_operation: sensor.data_operation
                        };
                        obj.sensores[groupIndex].items.push(groupObj);
                    }
                }
                if (nodo.derivados) {
                    for (const sensor of nodo.derivados) {
                        let groupIndex =obj?.sensores?.findIndex(item => item?.label===t("graficador.sensor_virtual"));
                        if(groupIndex===-1){
                            obj.sensores.push( {label: t("graficador.sensor_virtual"), items: []});
                            groupIndex = (obj?.sensores?.length) -1;
                        }
                        const groupObj = {
                            tipo: t("graficador.sensor_virtual"),
                            nodo_id: sensor.nodo_id,
                            sensor_id: parseInt("3" + sensor.sensor_virtual_derivado_id, 10),
                            nombre: sensor.nombre,
                            sist_tipo_sensor_id: sensor.sist_tipo_sensor_id,
                            simbolo: sensor.simbolo,
                            data_operation: sensor.data_operation,
                            original_id:sensor.sensor_virtual_derivado_id,
                        };
                        obj.sensores[groupIndex].items.push(groupObj);
                    }
                }
                arr.push(obj);
            }
            setDropdownData(arr);

            const _rows = rows;
            let lastKey = null;

            for (const r of _rows) {
                if (lastKey === null || lastKey < r.key) lastKey = r.key;
            }

            _rows.forEach((r) => {
                if (r.sensor && r.sensor !== null && r.sensor.traduccion) {
                    r.key = lastKey + 1;
                    lastKey = lastKey + 1;
                    r.sensor.nombre = (r.sensor.traduccion[i18n.language] ?? r.sensor.traduccion["en"]);
                }
            });
            setRows(_rows);
        }
    }, [t]);

    useEffect(() => {
        if (dataChart && fechasChart && sensoresChart) {
            updateChart(dataChart, fechasChart);
            updateTable(dataChart, sensoresChart);
        }
    }, [dataChart, fechasChart, sensoresChart, t]);


    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + EXCEL_EXTENSION);
            }
        });
    };
    function customSort(a, b) {
        if (a === "fecha") {
            return -1;
        } else if (b === "fecha") {
            return 1;
        } else {
            return a.localeCompare(b);
        }
    }
    function formatDateToAAAAMMDD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}${month}${day}`;
        return formattedDate;
    }
    const exportTable = (data) => {
        const dates = data.map(e => {
            const d = new Date(e.fecha);
            return d.toISOString();
        });
        import("xlsx").then((xlsx) => {
            const copyTable = [];
            data.forEach((o, index) => {
                const ids = Object.keys(o);
                const newObj = {};
                ids.forEach(sensor_id => {
                    if(sensor_id !== "fecha"){
                        newObj[columnDict[sensor_id]] = o[sensor_id];
                    }else{
                        newObj["fecha"] = dates[index];
                    }
                });
                copyTable.push(newObj);
            });
            const keys = Object.keys(copyTable[0]);
            const headers = keys.map(key => columnDict[key] || key);
            headers.sort(customSort);
            const worksheet = xlsx.utils.json_to_sheet(copyTable, {header:headers});
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });
            saveAsExcelFile(excelBuffer, `${t("forms.chartData")} - ${dataFarm.nombre} - ${formatDateToAAAAMMDD(rangeDates[0])}_${formatDateToAAAAMMDD(rangeDates[1])}`);
        });
    };
    return (
        <div className='row-container'>
            <div className="row">
                <div className="col">
                    <div id="cardGraficador" className="card" >
                        {dataLoading && <LoadingDialog appendTo="self" />}
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4'>
                                    {selfHelpGraficador &&
                                        <SelfHelp t={t} lng={i18n.language} params={selfHelpGraficador} fertiTable />}
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("forms.graficadorLibre")}</span></h5>
                                </div>
                            </div>

                            <div className='linea-titulo' />

                            <div className='row'>
                                {showValidationGraficador &&
                                    <div className="col-12 msgRawValidation">
                                        <span>{t("forms.msgValidacionGraficador")}</span>
                                    </div>}
                                {showValidationGraficadorUnique &&
                                    <div className="col-12 msgRawValidation">
                                        <span>{t("forms.msgValidacionGraficadorUnico")}</span>
                                    </div>}
                                <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                                    <ButtonPrime label={t("graficador.add")} onClick={addRow} disabled={limitSensor} visible={!limitSensor} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-9 text-md-right mtem-05"  />
                            </div>
                            <br />
                            {dropdownData && rows.map((row, index) => (
                                <GraficadorRow key={row.key}
                                    dropdownData={dropdownData}
                                    nodesInfo={nodesInfo}
                                    t={t}
                                    obj={row}
                                    index={index}
                                    rows={rows}
                                    updateRow={updateRow}
                                    removeRow={removeRow}
                                    addRowNextNodo={addRowNextNodo}
                                    addRowNextSensor={addRowNextSensor}
                                    rowsLength={rows.length}
                                />
                            ))}
                            <div className='linea-titulo' />

                            <div className='row'>
                                <div className="col-12 col-md-5 text-md-right mtem-05">
                                    <label className="boldie">{t("forms.rangoFechas")}</label>
                                </div>

                                <div className="col-12 col-md-5 col-lg-3 text-md-left mtem-05">
                                    <div>
                                        <CalendarPrime
                                            id="daterangepicker"
                                            t={t}
                                            minDate={sixMonths}
                                            maxDate={today}
                                            maxDaysRange={90}
                                            setValue={setRangeDates}
                                            value={rangeDates}  onChange={(e) => setRangeDates(e.value)}
                                            locale={i18n.language}
                                            selectionMode="range"
                                            presets
                                        />
                                    </div>

                                </div>
                                <div className="col-12 col-md-5 col-lg-3 text-md-left mtem-05">
                                    <ButtonPrime label={t("forms.ver")} onClick={() => obtenerDatos(rangeDates)} small />
                                </div>
                                {showValidation &&
                                    <div className="col-12 msgRawValidation">
                                        <span>{t("forms.msgValidacionRangoFechas")}</span>
                                    </div>}
                                {showValidation6M &&
                                    <div className="col-12 msgRawValidation">
                                        <span>{t("forms.msgValidacionRangoFechas6M")}</span>
                                    </div>}
                                {showValidation90Days &&
                                    <div className="col-12 msgRawValidation">
                                        <span>{t("forms.msgValidacionRangoFechas3M")}</span>
                                    </div>}
                            </div>

                            <div className='linea-titulo' />

                            <div className='row'>
                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                    <Charts options={options} menuIsOpen={menuIsOpen} t={t} />
                                </div>
                            </div>

                            <div className='linea-titulo' />

                            <div className='row'>
                                <div className="col-12">
                                    <label className="boldie">{t("graficador.tabla")}</label>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                    <DataTablePrime
                                        t={t}
                                        tableName="TableGraficador"
                                        items={tableData}
                                        paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
                                        dynamicColumns={tableRows}
                                        header="exportTable"
                                        exportFunction={(e) => {
                                            exportTable(tableData);
                                        }}
                                        paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default withName(Graficador, "GraficadorFrag");
